export const usePackStore = defineStore('packStore', {
    state: () => ({
        packs: []
    }),


    actions: {
        async getPack() {
            const api = useApi()
            const packs = await api.getPacks()
            this.packs = packs
        }
    }
})